/*
 * File: DateInput.tsx
 * Author: Austin Robinson
 * Date Created: 10/18/2023
 * Copyright (c) DrivingDoc 2023
 */
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import { Controller, useFormContext } from 'react-hook-form';

interface PropTypes extends DatePickerProps<Dayjs> {
  name: string;
  label: string;
  helperText?: string;
}

export default function DateInput({ name, label, helperText, ...props }: PropTypes) {
  const { control } = useFormContext();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState }) => {
          return (
            <DatePicker
              name={name}
              label={label}
              slotProps={{
                textField: {
                  variant: 'standard',
                  fullWidth: true,
                  InputLabelProps: { shrink: true },
                  error: !!fieldState.error,
                  helperText: fieldState.error?.message ?? helperText,
                  onBlur: field.onBlur,
                  // InputProps: {
                  //     endAdornment: <IconButton aria-label="Choose date" size="medium"><EventIcon /></IconButton>
                  // }
                  // slotProps: {
                  //     input: {
                  //         endAdornment: <InputAdornment position="end">%</InputAdornment>,
                  //     }
                  // }
                },
              }}
              inputRef={field.ref}
              // value={field?.value ? dayjs(field.value) : null}
              value={dayjs(field.value)}
              onChange={(newValue) => {
                if (newValue && dayjs(newValue).isValid()) {
                  // field.onChange(dayjs(newValue).format('YYYY-MM-DD'));
                  field.onChange(dayjs(newValue).startOf('day').toISOString());
                }
                // field.onChange(dayjs(newValue).format('YYYY-MM-DD'));
              }}
              // onChange={(newValue) => {
              //     // field.onChange(dayjs(newValue).toISOString());
              //     console.log('newValue', newValue);
              //     // if (newValue && newValue.isValid()) {
              //     // field.onChange(dayjs(newValue).startOf('minute'));
              //     field.onChange(dayjs(newValue).startOf('minute'));
              //     // }
              // }}
              onError={(newError) => console.log(`Date Error: ${newError}`)}
              {...props}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
}
